import { useCanEditNewsEventArticle } from "features/NewsEvents/hooks/useCanEditNewsEventArticle";
import { parseAsBoolean, useQueryState } from "nuqs";
import { SingleNewsPageEdit } from "./SingleNewsPageEdit";
import { SingleNewsPageView } from "./SingleNewsPageView";

export function SingleNewsPage() {
  const [editMode] = useQueryState("edit", parseAsBoolean.withDefault(false));
  const canEdit = useCanEditNewsEventArticle();
  const showEdit = canEdit && editMode;
  return showEdit ? (
    <SingleNewsPageEdit />
  ) : (
    <SingleNewsPageView canEdit={canEdit} />
  );
}
